
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import LunchScreen from './lunch';
import translate from '../../helpers/translate';


function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showLunch, setShowLunch] = useState(false);
     const [dishs, setdishs] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);

    
    return (
        <div style={{ position: 'absolute', top: 1, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
            <LayoutContent showLamp={ false} showBack={true} showImageTop={false}  setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={setShowSpecials}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {
                            if (![443, 444, 445, 446, 447, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564].includes(item.id)) {
                                return <div key={key} style={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                width: 340,
                                position: "relative"
                            }}
                                    onClick={() => { 
                                    
                                        if (item.id === 338) {
                                            setShowLunch(true)
                                        } else {
                                            setShowListProduct(true)
                                            setdishs(item)
                                        }
                                   
                                }}
                                >
                                    {/* fontFamily: 'WallAxe', */}
                                    <p className='text-shadow' style={{ position: 'absolute', textTransform: 'uppercase', color: 'white', fontWeight: "900", fontSize: 30 }}>
                                      
                                        {langEng ? item.name : translate(i18n.language, item.language, item.name)}
                                    
                                    </p>
                                <img
                                    src={`https://tumenu.online/images/categories/icons/${item.icon}`}
                                    style={{
                                        marginTop: 10,
                                        width: '100%',
                                        height: 210,
                                        objectFit: 'cover',
                                        borderRadius: 20,
                                    }}
                                />

                            </div>
                            }
                            
                        })}
                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showLunch && <LunchScreen setShowListProduct={setShowLunch} setShowHappy={setshowCategories} />}
                

                
            </LayoutContent>
        </div>
    );
}
export default Index;